import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { PlannerV2AreasGetInBoundingBoxDocument, PlannerV2AreasGetInBoundingBoxQueryVariables } from "./queries.generated";

export default function useGetAllPlannerV2AreasGetInBoundingBox(params: PlannerV2AreasGetInBoundingBoxQueryVariables) {
    const { data, loading, error, previousData } = useQuery(PlannerV2AreasGetInBoundingBoxDocument, {
        variables: params,
    });

    return {
        loading,
        error,
        data: useMemo(() => {
            // Record<string, PlannerArea[]>
            const plannerAreasPerStatusBucketRaw =
                data?.plannerV2AreasGetInBoundingBox ?? previousData?.plannerV2AreasGetInBoundingBox;

            // Array<PlannerArea[]>
            const { __typename, ...plannerAreasPerStatusBucket } = plannerAreasPerStatusBucketRaw ?? {};
            const plannerAreas = Object.values(plannerAreasPerStatusBucket).flat();

            // Map<string, PlannerArea>
            const plannerAreaById = new Map(plannerAreas.map(element => [element.id, element]));

            const maxRequiredFieldworkers =
                data?.plannerV2MaxRequiredFieldworkersGetInBoundingBox ??
                previousData?.plannerV2MaxRequiredFieldworkersGetInBoundingBox;

            return {
                plannerAreasPerStatusBucket,
                plannerAreaById,
                plannerAreas,
                maxRequiredFieldworkers: maxRequiredFieldworkers ?? 0,
            };
        }, [data, previousData]),
    };
}
